// src/contexts/HealthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import Tools from "../utils/Tools";

const HealthContext = createContext();

export const HealthProvider = ({ children }) => {
    const [summary, setSummary] = useState(null);
    const [loadingSummary, setLoadingSummary] = useState(true);

    useEffect(() => {
        setLoadingSummary(true);
        Tools.sendRequest("get-health-status-auth")
            .then((response) => {
                // First record is the latest.
                setSummary(response.healthHistory[0]);
                setLoadingSummary(false);
            })
            .catch((error) => {
                console.error("Error fetching summary:", error);
                setLoadingSummary(false);
            });
    }, []);

    return (
        <HealthContext.Provider value={{ summary, loadingSummary, setSummary }}>
            {children}
        </HealthContext.Provider>
    );
};

export const useHealth = () => useContext(HealthContext);